module.exports = __webpack_public_path__ + "img/title.b6bf4b5b.png";